import { render, staticRenderFns } from "./BattleScreen.vue?vue&type=template&id=5a6df89d&scoped=true"
import script from "./BattleScreen.vue?vue&type=script&lang=js"
export * from "./BattleScreen.vue?vue&type=script&lang=js"
import style0 from "./BattleScreen.vue?vue&type=style&index=0&id=5a6df89d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6df89d",
  null
  
)

export default component.exports